<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <SGPBotaoVoltarComponent class="mr-3" />
      <h1 class="mdn-Heading mdn-Heading--sm mb-0">
        Configuração de E-mail Automático
      </h1>
      <button
        v-if="templateAtual"
        type="button"
        class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default primary--text text-capitalize ml-4"
        @click="abrirModalDestinatarios"
      >
        <SGPIconComponent icon="mdi-account-multiple" class="mr-2" />
        Configurar Destinatários
        <span v-if="totalDestinatarios > 0" class="ml-2 badge badge-primary">
          {{ totalDestinatarios }}
        </span>
      </button>
    </div>

    <p v-if="templateAtual" class="text-muted mb-4">
      Ajuste os dados gerais do e-mail <strong>"{{ templateAtual.name }}"</strong>.
    </p>

    <div v-if="templateAtual">
      <FormularioEmailAutomaticoComponent
        tipoFormulario="editar"
        :template="templateAtual"
        :availableVariables="availableVariables"
        @fechar="voltarParaListagem"
      />
    </div>

    <SGPAlertaComponent v-else-if="!loadingTemplates">
      Não foi possível carregar este template.
    </SGPAlertaComponent>

    <SGPModalComponent
      v-if="modalDestinatariosAberto"
      tamanho="lg"
      titulo="Configurar destinatários"
      @sgpModalFechar="fecharModalDestinatarios"
      :mostrarFooter="false"
    >
      <DestinatariosModalComponent
        :recipients="recipients"
        :availableVariables="availableVariables"
        :salvando="salvandoTemplate"
        @salvar="salvarDestinatarios"
        @fechar="fecharModalDestinatarios"
      />
    </SGPModalComponent>

    <SGPLoadingComponent v-if="loadingTemplates || salvandoTemplate" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioEmailAutomaticoComponent from '../components/FormularioEmailAutomaticoComponent.vue'
import DestinatariosModalComponent from '../components/DestinatariosModalComponent.vue'

export default {
  name: 'ConfiguracaoEmailAutomaticoPage',

  components: {
    FormularioEmailAutomaticoComponent,
    DestinatariosModalComponent
  },

  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },

  data () {
    return {
      modalDestinatariosAberto: false
    }
  },

  computed: {
    ...mapGetters('gestaoEmailsAutomaticos', [
      'templateSelecionado',
      'loadingTemplates',
      'salvandoTemplate'
    ]),

    templateAtual () {
      return this.templateSelecionado
    },

    recipients () {
      return (this.templateAtual && this.templateAtual.recipients) || []
    },

    availableVariables () {
      return (this.templateAtual && this.templateAtual.available_variables) || []
    },

    totalDestinatarios () {
      return this.recipients.length
    }
  },

  watch: {
    id: {
      immediate: true,
      handler () {
        this.carregar()
      }
    }
  },

  beforeDestroy () {
    this.limparSelecionado()
  },

  methods: {
    ...mapActions('gestaoEmailsAutomaticos', [
      'buscarTemplate',
      'limparSelecionado',
      'atualizarTemplate'
    ]),

    async carregar () {
      await this.buscarTemplate(this.id)
    },

    abrirModalDestinatarios () {
      this.modalDestinatariosAberto = true
    },

    fecharModalDestinatarios () {
      this.modalDestinatariosAberto = false
    },

    async salvarDestinatarios (recipients) {
      const t = this.templateAtual
      await this.atualizarTemplate({
        id: t.id,
        name: t.name,
        description: t.description,
        subject: t.subject,
        body_view: t.body_view,
        is_active: t.is_active,
        recipients
      })
      this.fecharModalDestinatarios()
      await this.carregar()
    },

    voltarParaListagem () {
      this.$router.push({ name: 'gestao-emails-automaticos' })
    }
  }
}
</script>
